/** External dependencies */
import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';

if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    // fancybox defaults
    Fancybox.defaults.template = {
        closeButton:
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><g><circle cx="16" cy="16" r="16" stroke="none"/><circle cx="16" cy="16" r="15"/></g><g fill="none" stroke="#121212" stroke-width="2"><g stroke-linecap="round"><path d="m8 8 16 16"/><path d="M24 8 8 24"/></g></g></svg>',
    };

    // we need to render the like cloudflare turnstile manually after items get added to the page
    if (window.turnstile) {
        const restContainers = document.querySelectorAll(`.ct_petvideo[data-ct-rest]`);

        if (restContainers) {
            restContainers.forEach((restContainer) => {
                restContainer.addEventListener('ct.itemUpdated', (e) => {
                    const { target } = e;
                    const turnstile = target.querySelector(`.cf-turnstile`);
                    if (turnstile) {
                        window.turnstile.render(turnstile);
                    }
                });
            });
        }
    }

    const copyLinks = document.querySelectorAll('.copyclipboard');
    if (copyLinks) {
        copyLinks.forEach((link) => {
            link.addEventListener('click', () => {
                // reset class so animation plays again if user clicks twice
                link.classList.remove('copied');
                const urlToCopy = link.dataset.clipboardText;
                if (urlToCopy) {
                    navigator.clipboard.writeText(urlToCopy).then(() => {
                        link.classList.add('copied');
                    });
                }
            });
        });
    }
}
